import PublicOvertimeDetailContainer from './PublicOvertimeDetailContainer';

export default function OvertimeCustomerDetail(): JSX.Element {
  return <PublicOvertimeDetailContainer />;
}
